import axios from "../../axios/axios-censo";

export const pegaTiposLeito = ({ commit }, payload) => {
    
    return axios
    .get("listarGrupoTipoLeito.php")
    .then(resp => {
        resp.data.status == true ? commit("setTiposLeito", resp.data.dados) : commit("setTiposLeito", new Array())
    })
    .catch(error => {
        console.log(error)
    });

};
export const pegaMapaTipoLeito = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let config = {
        params: {
            idGrupoTipoLeito: payload
        }
    }
    
    return axios
    .get("listarEnfermariasLivres.php", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })
        resp.data.status == true ? commit("setMapaTipoLeito", resp.data.dados) : commit("setMapaTipoLeito", new Array())
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};